import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Form, Select } from 'antd';
import { withRouter } from 'react-router-dom';
import { parse } from 'qs';
import {
  getCompactMultiSelectMaxTagCount,
  getCompactMultiSelectPlaceholder,
} from '../../../utils/compactMultiSelect';

const AUTO_UPLOAD_OPTIONS = [
  { value: 'failedAutoUploaded', label: 'Failed' },
  { value: 'successfulAutoUploaded', label: 'Successful' },
  { value: 'autoUploadSendToChart', label: 'Send to Chart' },
  { value: 'autoUploadChartCreation', label: 'Create New Chart + Task' },
  { value: 'autoUploadTask', label: 'Create Task' },
];

const AUTO_UPLOAD_KEYS = AUTO_UPLOAD_OPTIONS.map((o) => o.value);

const AutoUploadFilters = ({ updateQuery, location }) => {
  const currentQuery = parse(location.search, { ignoreQueryPrefix: true });

  const selectedValues = useMemo(
    () => AUTO_UPLOAD_KEYS.filter((key) => currentQuery[key] === 'true' || currentQuery[key] === true),
    [currentQuery],
  );

  const handleChange = (values) => {
    const query = { ...currentQuery };

    // Remove all auto upload keys first
    AUTO_UPLOAD_KEYS.forEach((key) => delete query[key]);

    // Add back only selected ones
    values.forEach((key) => {
      query[key] = true;
    });

    updateQuery(query);
  };

  return (
    <Form.Item
      label="Auto Upload Status"
      style={{ marginTop: 10, display: 'block' }}
    >
      <Select
        className="compact-multi-select"
        mode="multiple"
        allowClear
        placeholder="All statuses"
        options={AUTO_UPLOAD_OPTIONS}
        onChange={handleChange}
        value={selectedValues}
        style={{ width: '100%' }}
        maxTagCount={getCompactMultiSelectMaxTagCount(selectedValues)}
        maxTagPlaceholder={getCompactMultiSelectPlaceholder('statuses')}
      />
    </Form.Item>
  );
};

AutoUploadFilters.defaultProps = {
  updateQuery: () => {},
  location: {},
};

AutoUploadFilters.propTypes = {
  updateQuery: PropTypes.func,
  location: PropTypes.object,
};

export default withRouter(AutoUploadFilters);
